import React, { useRef } from "react";
import MonacoEditor from "@monaco-editor/react";
import { Paper,  Box } from "@mui/material";

const Editor = ({ schema, onChange }) => {

  const editorRef = useRef(null);

  const handleEditorChange = (value) => {
    try {
      const parsedSchema = value ? JSON.parse(value) : {};
        const editor = editorRef.current;
        const position = editor?.getPosition(); 
        console.log("parsedSchema", parsedSchema);
        onChange(parsedSchema);
        setTimeout(() => {
          editor?.setPosition(position);
      }, 0);
    } catch (error) {
      console.error("Invalid JSON format", error);
    }
  };

  return (
    <Box >
      {/* <Typography variant="h6" marginBottom={2}>
        JSON Schema
      </Typography> */}
      <Box sx={{ border: "1px solid #ccc", borderRadius: 1, overflow: "hidden" }}>
        <MonacoEditor
          height="355px"
          language="json"
          theme="light"
          value={JSON.stringify(schema, null, 2)}
          onChange={handleEditorChange}
          options={{
            minimap: { enabled: false },
            scrollBeyondLastLine: false,
            automaticLayout: true,
            formatOnPaste: true, 
            formatOnType: true  
          }}
          onMount={(editor) => (editorRef.current = editor)}
        />
      </Box>
    </Box>
  );
};

export default Editor;
